import script from "./InventoryProfileBookCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryProfileBookCard.vue?vue&type=script&setup=true&lang=js"

import "./InventoryProfileBookCard.vue?vue&type=style&index=0&id=f3efe8de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3efe8de"]])

export default __exports__